import { withHTMLComponent } from '@updater-local/custom-element-v1';
import styles from './index.css';
const html = `<slot></slot>`;

export default class Heading extends withHTMLComponent(styles, html)() {}

customElements.define('upd-moveiq-heading', Heading);
